import { Controller } from "@hotwired/stimulus";
import { isIPhone, isIPad, isAndroid, isAndroidTab } from "@/src/front/common";

export default class extends Controller {
  static values = {
    needLoginModal: Boolean,
    needAdsModal: Boolean,
    skipLoadGame: Boolean,
    redirectPath: String
  };

  loginModalElemet = $("[data-remodal-id=modalCidLogin]");
  adsModalElemet = $("[data-remodal-id=modalAdGame]");
  adsCompletedModalElemet = $("[data-remodal-id=modalAdGameCompleted]");

  playThumnailContainer = $("#play-thumnail");
  playScreenContainer = $("#play-screen");
  playControllerContainer = $("#play-controller");
  playSideNavControllerContainer = $("#play-side-nav-controller");
  playSideNavManualContainer = $("#play-side-nav-manual");

  playButtonElement = document.querySelector("#play-button");
  playAdsButtonElement = document.querySelector("#play-ads-button");
  rejectAdsButtonElement = document.querySelector("#reject-ads-button");
  grantAdsButtonElement = document.querySelector("#grant-ads-button");
  rejectButtonButtonElement = document.querySelector("#reject-login-button");

  loginModal = this.loginModalElemet.remodal({
    hashTracking: false,
    closeOnEscape: false,
    closeOnOutsideClick: false,
    modifier: "remodal-cid-login"
  });

  adsModal = this.adsModalElemet.remodal({
    hashTracking: false,
    closeOnEscape: false,
    closeOnOutsideClick: false,
    modifier: "remodal-ads-reward"
  });

  adsCompletedModal = this.adsCompletedModalElemet.remodal({
    hashTracking: false,
    closeOnEscape: false,
    closeOnOutsideClick: false,
    modifier: "remodal-ads-reward-granted"
  });

  emuUrl = "";
  wasHashInUrl = false;
  hasLoaded = false;

  initialize() {
    if (this.isSP()) {
      this.playThumnailContainer.addClass("js-only-sp");
    }
    if (this.isTB()) {
      this.playThumnailContainer.addClass("js-only-tb");
    }

    this.unloadPlayElements();

    if (this.isPlayable()) {
      this.cacheEmuURL();

      if (this.needAdsModalValue) {
        this.initializeAdsModal();

      } else if (this.skipLoadGameValue) {
        this.processNoModal();

      } else if (this.needLoginModalValue) {
        this.initializeLoginModal();

      } else {
        this.initializeNoModal();
      }
    }
  }


  /**
   * モーダルなし
   */
  initializeNoModal() {
    this.playButtonElement.addEventListener("click", this.processNoModal.bind(this));
  }

  processNoModal() {
    if (this.isSP() || this.isTB()) {
      this.redirectToSpPlay();
    } else {
      this.loadPlayElements();
    }
  }

  /**
   * CIDログインモーダル
   */
  initializeLoginModal() {
    this.playButtonElement.addEventListener("click", this.processLoginModal.bind(this));
    this.rejectButtonButtonElement.addEventListener("click", this.onLoginReject.bind(this));
  }

  processLoginModal() {
    this.loginModal.open();
  }

  onLoginReject() {
    this.loginModal.close();
  }

  /**
   * リワード広告モーダル
   */
  initializeAdsModal() {
    this.playButtonElement.addEventListener("click", this.processAdsModal.bind(this));
    this.playAdsButtonElement.addEventListener("click", this.onAdsPlay.bind(this));
    this.rejectAdsButtonElement.addEventListener("click", this.onAdsReject.bind(this));
    this.grantAdsButtonElement.addEventListener("click", () => { this.adsCompletedModal.close(); });
    this.adsCompletedModalElemet.on("closed", this.onAdsCompleted.bind(this));

    this.googletag = window.googletag || { cmd: [] };
  }

  processAdsModal() {
    this.adsModal.open();
  }

  onAdsPlay() {
    this.googletag.cmd.push(this.setupAds.bind(this));
  }

  setupAds() {
    this.wasHashInUrl = window.location.hash === "#goog_rewarded";

    this.rewardedSlot = this.googletag.defineOutOfPageSlot(
      //テスト広告
      // "/22639388115/rewarded_web_example",
      //本番広告
      "/23311213052/CapcomTown_browser_game/browser_game_preroll",
      this.googletag.enums.OutOfPageFormat.REWARDED
    );

    this.rewardedSlot.addService(this.googletag.pubads());

    this.googletag.enableServices();

    this.googletag.pubads().addEventListener("rewardedSlotReady", (e) => { this.onAdsReady.bind(this)(e); });
    this.googletag.pubads().addEventListener("rewardedSlotGranted", this.onAdsGranted.bind(this));
    this.googletag.pubads().addEventListener("rewardedSlotClosed", this.onAdsClosed.bind(this));

    this.googletag.display(this.rewardedSlot);
  }

  onAdsReady(e) {
    this.adsModal.close();
    e.makeRewardedVisible();
  }

  onAdsReject() {
    this.adsModal.close();
  }

  onAdsClosed() {
    location.reload();
  }

  onAdsGranted() {
    this.googletag.destroySlots([this.rewardedSlot]);
    this.adsCompletedModal.open();
  }

  onAdsCompleted() {
    if (this.wasHashInUrl) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    } else {
      history.back();
    }

    if (this.isSP() || this.isTB()) {
      this.redirectToSpPlay();

    } else {
      this.loadPlayElements();
    }
  }


  /**
   * ヘルパー
   */

  isSP() {
    return isIPhone || isAndroid;
  }

  isTB() {
    return isIPad || isAndroidTab;
  }

  isPlayable() {
    return document.querySelector("#game-loader") != null;
  }

  unloadPlayElements() {
    this.playScreenContainer.hide();
    this.playControllerContainer.hide();
    this.playSideNavControllerContainer.hide();
    if (!this.isSP() && !this.isTB()) this.playSideNavManualContainer.hide();
  }

  cacheEmuURL() {
    const gameLoaderContainer = document.querySelector("#game-loader");
    const emuURLElement = gameLoaderContainer.querySelector("#emu_url");
    this.emuUrl = emuURLElement.value;
    emuURLElement.remove();
  }

  checkRomExpiration() {
    const romUrl = document.querySelector("#rom_url").value;
    const urlObj = new URL(romUrl, window.location.origin);
    const expires = urlObj.searchParams.get("Expires");
    const expiresTimestamp = parseInt(expires);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return expiresTimestamp < currentTimestamp;
  }

  async reloadRom() {
    const currentUrl = window.location.href;
    const response = await fetch(currentUrl, {
      method: "GET",
      headers: {
        "Accept": "text/html",
        "Content-Type": "text/html",
        "User-Agent": navigator.userAgent,
      }
    });
    const htmlText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const newRomURL = doc.querySelector("#rom_url").value;
    const romURLElement = document.querySelector("#rom_url");
    romURLElement.value = newRomURL;
  }

  loadPlayElements() {
    if (this.hasLoaded == true) return;
    this.hasLoaded = true;

    this.playButtonElement.remove();

    this.playThumnailContainer.hide();
    this.playScreenContainer.show();
    this.playControllerContainer.show();
    this.playSideNavControllerContainer.show();
    this.playSideNavManualContainer.show();

    this.loadEmulator();

    $(window).scrollTop(0);
  }

  async loadEmulator() {
    if (this.checkRomExpiration()) await this.reloadRom();

    const gameLoaderContainer = document.querySelector("#game-loader");
    const emuScriptElement = document.createElement("script");
    emuScriptElement.src = this.emuUrl;

    gameLoaderContainer.appendChild(emuScriptElement);
  }

  redirectToSpPlay() {
    window.location.href = this.redirectPathValue;
  }
}
